import { useAppContext } from 'hooks/context/useAppContext';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { formatCurrency, TAvailableCurrencies } from 'utils/helpers';

import { PackageItem } from './types';

export function PackagesContainer() {
  const {
    components: { Layout },
    pages: { Packages },
  } = useGGTheme();

  const { packages } = useAppContext();

  const packageList: PackageItem[] = packages.map((packageItem) => ({
    ...packageItem,
    price: formatCurrency(
      packageItem.price.value / 100,
      packageItem.price.currency as TAvailableCurrencies,
    ),
  }));

  return (
    <Layout>
      <Packages packageList={packageList} />
    </Layout>
  );
}
